/* ============================================
   COTTON MINIMAL THEME - Global JS
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {
  initMobileMenu();
  initHeroSlider();
  initProductCarousels();
  initQuantityButtons();
  initVariantSelectors();
  initStickyHeader();
});

/* Sticky Header - switches to fixed when scrolled past announcement bar */
function initStickyHeader() {
  const header = document.querySelector('.header');
  const announcementBar = document.querySelector('.announcement-bar');
  
  if (!header) return;
  
  // Create a spacer element to prevent content jump when header becomes fixed
  const spacer = document.createElement('div');
  spacer.className = 'header-spacer';
  header.parentNode.insertBefore(spacer, header.nextSibling);
  
  let isFixed = false;
  let headerHeight = header.offsetHeight;
  
  function updateHeader() {
    const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
    
    // Update header height in case of resize
    if (!isFixed) {
      headerHeight = header.offsetHeight;
    }
    
    if (scrollY >= announcementHeight) {
      // User scrolled past announcement bar - make header fixed
      if (!isFixed) {
        spacer.style.height = headerHeight + 'px';
        spacer.classList.add('is-active');
        header.classList.add('is-fixed');
        header.classList.add('is-stuck');
        isFixed = true;
      }
    } else {
      // User is at top - normal flow
      if (isFixed) {
        spacer.classList.remove('is-active');
        spacer.style.height = '0';
        header.classList.remove('is-fixed');
        header.classList.remove('is-stuck');
        isFixed = false;
      }
    }
  }
  
  // Throttle scroll with requestAnimationFrame
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        updateHeader();
        ticking = false;
      });
      ticking = true;
    }
  }
  
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function() {
    headerHeight = header.offsetHeight;
    if (isFixed) spacer.style.height = headerHeight + 'px';
  }, { passive: true });
  
  // Run once on load
  updateHeader();
}

/* Mobile Menu */
function initMobileMenu() {
  const toggle = document.querySelector('.mobile-menu-toggle');
  const menu = document.querySelector('.mobile-menu');
  const overlay = document.querySelector('.mobile-menu-overlay');
  const closeBtn = document.querySelector('.mobile-menu__close button');

  if (!toggle || !menu) return;

  toggle.addEventListener('click', function() {
    menu.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  });

  function closeMenu() {
    menu.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);
}

/* Hero Slideshow */
function initHeroSlider() {
  const slides = document.querySelectorAll('.hero__slide');
  const dots = document.querySelectorAll('.hero__dot');
  
  if (slides.length <= 1) return;

  let current = 0;

  function showSlide(index) {
    slides.forEach(s => s.classList.remove('active'));
    dots.forEach(d => d.classList.remove('active'));
    slides[index].classList.add('active');
    if (dots[index]) dots[index].classList.add('active');
    current = index;
  }

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => showSlide(i));
  });

  setInterval(() => {
    const next = (current + 1) % slides.length;
    showSlide(next);
  }, 5000);
}

/* Product Carousels - Basic horizontal scroll */
function initProductCarousels() {
  const carousels = document.querySelectorAll('.product-grid--carousel');
  
  carousels.forEach(carousel => {
    let isDown = false;
    let startX, scrollLeft;

    carousel.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
    });

    carousel.addEventListener('mouseleave', () => isDown = false);
    carousel.addEventListener('mouseup', () => isDown = false);

    carousel.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - carousel.offsetLeft;
      const walk = (x - startX) * 2;
      carousel.scrollLeft = scrollLeft - walk;
    });
  });
}

/* Quantity Buttons */
function initQuantityButtons() {
  document.addEventListener('click', function(e) {
    if (e.target.matches('.quantity-minus')) {
      const input = e.target.parentElement.querySelector('input');
      const val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
    }
    if (e.target.matches('.quantity-plus')) {
      const input = e.target.parentElement.querySelector('input');
      const val = parseInt(input.value) || 1;
      input.value = val + 1;
    }
  });
}

/* Variant Selectors */
function initVariantSelectors() {
  document.querySelectorAll('.product__variant').forEach(variant => {
    variant.addEventListener('click', function() {
      const group = this.parentElement;
      group.querySelectorAll('.product__variant').forEach(v => v.classList.remove('active'));
      this.classList.add('active');
    });
  });
}

/* Smooth scroll for anchor links */
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
});
